import { select, setStyle } from 'helpers/dom'
import { emitterProps, globalEmitter } from 'helpers/emitter-event'

const selectors = {
  COLLECTION_BANNER: '.js-collection-banner',
  COLLECTION_BANNER_SKELETON: '.js-collection-banner-skeleton',
  COLLECTION_NOSTO_BANNER: '.js-nosto-banner',
  COLLECTION_NOSTO_BANNER_CONTENT: '.js-nosto-banner-content'
}

export default class CollectionBanner extends HTMLElement {
  constructor() {
    super()

    this.collectionBanner = select(selectors.COLLECTION_BANNER, this)
    this.collectionBannerSkeleton = select(selectors.COLLECTION_BANNER_SKELETON, this)
    this.placement = this.collectionBanner.children[0].className
    this.addSkeleton()
  }

  addSkeleton() {
    globalEmitter.on(emitterProps.recommendations.campaigns, (values) => {
      const html = values[this.placement]?.html

      if (html !== undefined) {
        this.collectionBanner.style.display = 'block'
        this.collectionBanner.children[0].innerHTML = html

        if (this.collectionBannerSkeleton) {
          this.collectionBannerSkeleton.style.display = 'none'
        }
      }
    })
  }

  replaceContent() {
    let count = 0
    const interval = setInterval(() => {
      const nostoBannerEl = select(selectors.COLLECTION_NOSTO_BANNER, this)

      if (nostoBannerEl || count === 10) {
        clearInterval(interval)

        if (nostoBannerEl?.getAttribute('use-shopify-data') === 'true') {
          const nostoBannerContentEl = select(selectors.COLLECTION_NOSTO_BANNER_CONTENT, nostoBannerEl)

          if (nostoBannerContentEl) {
            setStyle('display', 'block', nostoBannerContentEl)
            nostoBannerContentEl.innerHTML = `
              <h1 class="nosto__banner--title">${collectionTitle}</h1>
              <read-more class="nosto__banner--description wysiwyg--collection-banner">${collectionDescription ?? ''}</read-more>
            `
          }
        }
      } else {
        count++
      }
    }, 300)
  }
}

if (!customElements.get('collection-banner')) {
  customElements.define('collection-banner', CollectionBanner)
}
